import { ThreeDot } from "react-loading-indicators";

const CreateGroupModal = ({newGroupImage,showCreateGroup,newGroupName,setNewGroupName,setNewGroupImage,handleCreateGroupSubmit,loading,setShowCreateGroup}) => {
  return (
    <>
      {showCreateGroup && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white w-full max-w-md rounded-2xl shadow-xl overflow-hidden">
            {/* Modal Header */}
            <div className="p-6 border-b border-gray-100">
              <div className="flex items-center gap-3">
                <div className="w-10 h-10 bg-[#e8f0f7] rounded-lg flex items-center justify-center">
                  <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                </div>
                <div>
                  <h3 className="text-lg font-semibold text-gray-900">Create New Group</h3>
                  <p className="text-sm text-gray-500 mt-0.5">Add members and customize your group</p>
                </div>
              </div>
            </div>

            {/* Modal Content */}
            <div className="p-6">
              <div className="space-y-5">
                {/* Group Name Input */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-2">
                    Group Name
                  </label>
                  <input
                    type="text"
                    placeholder="Enter group name"
                    value={newGroupName}
                    onChange={(e) => setNewGroupName(e.target.value)}
                    className="w-full px-4 py-3 border border-gray-300 rounded-xl text-gray-900 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#0f6abf]/30 focus:border-[#0f6abf] transition-all"
                  />
                </div>

                {/* Image Upload */}
              <div>
  <label className="block text-sm font-medium text-gray-700 mb-2">
    Group Photo (Optional)
  </label>
  <div className="relative">
    <input
      type="file"
      accept="image/*"
      onChange={(e) => setNewGroupImage(e.target.files[0])}
      className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
      id="group-image"
    />
    
    {newGroupImage ? (
      <div className="border-2 border-solid border-[#0f6abf] rounded-xl p-4 text-center bg-[#e8f0f7]/10 transition-colors">
        <div className="w-24 h-24 rounded-lg overflow-hidden mx-auto mb-3 border-2 border-white shadow-sm">
          <img 
            src={URL.createObjectURL(newGroupImage)} 
            alt="Preview" 
            className="w-full h-full object-cover"
          />
        </div>
        <p className="text-sm text-gray-600">Click to change photo</p>
        <p className="text-xs text-gray-400 mt-1">
          {newGroupImage.name} • {(newGroupImage.size / 1024 / 1024).toFixed(2)} MB
        </p>
      </div>
    ) : (
      <div className="border-2 border-dashed border-gray-300 rounded-xl p-6 text-center hover:border-[#0f6abf] hover:bg-[#e8f0f7]/10 transition-colors">
        <div className="w-12 h-12 bg-[#e8f0f7] rounded-lg flex items-center justify-center mx-auto mb-3">
          <svg className="w-5 h-5 text-[#0f6abf]" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
          </svg>
        </div>
        <p className="text-sm text-gray-600">Click to upload group photo</p>
        <p className="text-xs text-gray-400 mt-1">PNG, JPG up to 5MB</p>
      </div>
    )}
  </div>
</div>
              </div>
            </div>

            {/* Modal Footer */}
            <div className="px-6 py-4 bg-gray-50/50 border-t border-gray-100">
              <div className="flex items-center justify-end gap-3">
                <button
                  className="px-5 py-2.5 text-gray-700 font-medium rounded-xl hover:bg-gray-100 transition-colors"
                  onClick={() => setShowCreateGroup(false)}
                >
                  Cancel
                </button>
                <button
                  className="px-5 py-2.5 bg-[#0f6abf] text-white font-medium rounded-xl hover:bg-[#0a5ca8] transition-colors flex items-center gap-2 min-w-[100px] justify-center"
                  onClick={handleCreateGroupSubmit}
                  disabled={loading}
                >
                  {loading ? (
                    <ThreeDot color={["#ffffff"]} size="small" />
                  ) : (
                    <>
                      <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 4v16m8-8H4" />
                      </svg>
                      Create Group
                    </>
                  )}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default CreateGroupModal